import { Button } from '@fabric-ds/react';
import { IconEdit16 } from '@fabric-ds/icons/react';
import type { Filters } from '@/domain';
import { formatReadableDateShortNoWeekday, parseISO } from '../../../../../../../shared/frontend-resources/src/util/datetime-fns';

export interface Props {
    openSearchForm: () => void;
    filters: Filters;
}

export const SearchDetails = ({ openSearchForm, filters }: Props) => {
    const showAccommodationDetails =
        !(filters.no_of_bedrooms_from === undefined || filters.no_of_bedrooms_from < 1) ||
        !(filters.no_of_beds_from === undefined || filters.no_of_beds_from < 1);

    const alignIcon =
        showAccommodationDetails && ((filters.booking_from && filters.booking_to) || filters.city || filters.country) ? 'items-end' : '';

    const renderSearchDetails = () => (
        <div data-testid="searchDetails" className="flex gap-16 align-text-bottom">
            {filters.booking_from && filters.booking_to ? (
                <div data-testid="searchDates" className="whitespace-nowrap font-bold">
                    {formatReadableDateShortNoWeekday(parseISO(filters.booking_from))}
                    {' - '}
                    {formatReadableDateShortNoWeekday(parseISO(filters.booking_to))}
                </div>
            ) : null}
            <div className="whitespace-nowrap font-bold">{filters.city ? filters.city : filters.country}</div>
        </div>
    );

    const renderAccommodationDetails = () => (
        // biome-ignore lint/style/noUnusedTemplateLiteral: <explanation>
        <div data-testid="accommodationDetails" className="flex items-center">
            {!(filters.no_of_bedrooms_from === undefined || filters.no_of_bedrooms_from < 1) && (
                <div data-testid="searchBeds" className="whitespace-nowrap mr-8">
                    {filters.no_of_bedrooms_from} soverom
                </div>
            )}
            {!(filters.no_of_beds_from === undefined || filters.no_of_beds_from < 1) && (
                <div className="whitespace-nowrap">{filters.no_of_beds_from} sengeplasser</div>
            )}
        </div>
    );

    return (
        <section data-testid="fhhSearchDetailsContent" className="flex gap-16 flex-1 justify-between mx-2 my-16">
            <div>
                {renderSearchDetails()}
                {showAccommodationDetails ? renderAccommodationDetails() : null}
            </div>
            <Button
                small
                link
                data-testid="openSearchFormButton"
                className={`flex ${alignIcon} mb-4`}
                title="Søk på nytt"
                aria-label="search"
                onClick={openSearchForm}>
                <IconEdit16 />
            </Button>
        </section>
    );
};
